/* globals AlertDTO*/
require('tooltipster');
require('mailcheck');
var jquery = require('jquery');
var Functions = require('./functions');
var HabEvents = require('../../Global/habitaclia-events');

(function () {
    'use strict';

    var Alert = function (alertDTO) {
        this.__alertDTO = alertDTO;

        __registerEvents.call(this);
    };


    var __registerEvents = function () {
        var self = this;

        jquery('#id_email_FormAlerta, #id_email_FormAlerta_0, #id_email_FormAlerta_1, #id_email_FormAlerta_2, #id_email_FormAlerta_3, #id_email_FormAlerta_fc').keyup(function () {
            var $email = this;
            var numero = '';

            if ($email.id.substring($email.id.length - 2, $email.id.length - 1) === '_') {
                numero = $email.id.substring($email.id.length - 2, $email.id.length);
            }

            var $formAlerta = jquery("#idFormAlerta" + numero);
            __fnCheckEmailAlerta.call(self, $formAlerta);
        });

        jquery("#idFormAlerta_0, #idFormAlerta_3").on("submit", function (e) {
            e.preventDefault();
            e.stopPropagation();
            __fnRegistrarAlerta.call(self, jquery(this));
        });

        jquery("#idFormAlerta_1, #idFormAlerta_2").on("submit", function (e) {
            e.preventDefault();
            e.stopPropagation();
            __fnRegistrarAlertaInmueble.call(self, jquery(this));
        });

    };

    var __typewatch = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    var __fnCheckEmailAlerta = function ($Form) {
        var self = this;

        var numero = '';

        if ($Form.attr('id').substring($Form.attr('id').length - 2, $Form.attr('id').length - 1) === '_') {
            numero = $Form.attr('id').substring($Form.attr('id').length - 2, $Form.attr('id').length);
        }
        var $Email = $Form.find('#id_email_FormAlerta, #id_email_FormAlerta_0, #id_email_FormAlerta_1, #id_email_FormAlerta_2, #id_email_FormAlerta_3');
        __typewatch(function () {
            $Email.mailcheck({
                //domains: domains,   // optional
                suggested: function (element, suggestion) {

                    $Form.find("#mailalertacheck").css("display", "block")
                        .html("<span style='font-size:12px;'>¿"
                            + self.__alertDTO.Translate.quizasQisoDecir
                            + " <span class='aspectolink' onclick=\"$('#" + $Form.attr("id") + " #id_email_FormAlerta" + numero + "').val('" + decodeURI(suggestion.full) + "');$('#" + $Form.attr("id") + " #mailalertacheck').html('');$('#" + $Form.attr("id") + " #mailalertacheck').attr('style','');\">" + decodeURI(suggestion.address) + "@<b>" + decodeURI(suggestion.domain) + "</b></span>? </span>");
                },
                empty: function () {
                    $Form.find('#mailalertacheck').html('').attr('style', '');
                }
            });
        }, 700);
    };

    var __fnRegistrarAlerta = function ($Form) {
        var self = this;
        var $Email, $Error, sError, numForm;
        var isLegalChecked = jquery('#idCheckLegal').prop('checked');
        if (isLegalChecked) {
            jquery('#idCheckLegal').attr('checked', '').val('si');
        }
        numForm = '';
        if ($Form.attr('id').indexOf('_')) {
            numForm = '_' + $Form.attr('id').split('_')[1];
        }
        $Email = $Form.find('#id_email_FormAlerta' + numForm);
        $Error = jquery('#idHabDialogAlertaFichaInmueble .error-texto');
        $Form.find('.loadingRegistrarAlerta').removeClass('ocultar').addClass('mostrar');
        sError = '';

        if ($Email.val() === '' || !Functions.ValidateEmail($Email[0])) {
            $Form.find('.loadingRegistrarAlerta').removeClass('mostrar').addClass('ocultar');
            sError = ($Email.val() === '') ? self.__alertDTO.Translate.idErrBadMailEmpty : self.__alertDTO.Translate.idErrBadMail;

            if ($Form.hasClass('isHabDialog')) {
                $Error.removeClass('ocultar').addClass('mostrar').html(sError);
                $Form.find('#id_email_FormAlerta' + numForm).addClass('error');
            } else {
                alert(sError);
            }

            jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-alerta_ficha_inmueble', 'Email incorrecto o no informado']);
            return false;
        } else if (!isLegalChecked) {
            alert(self.__alertDTO.Translate.LegalObligatory);
        } else {
            if ($Form.hasClass('isHabDialog')) {
                $Error.removeClass('mostrar').addClass('ocultar').html('');
                $Form.find('#id_email_FormAlerta' + numForm).removeClass('error');
            }
            jquery.post(self.__alertDTO.UrlRegistrarAlerta, $Form.serialize(), function (data) {
                if (data.status === 0) {
                    var $RemoveForm, $RemoveTituloAlerta;
                    $RemoveTituloAlerta = jquery('.titFormAlerta');
                    $RemoveForm = jquery('.frmRegistrarAlerta.listado');
                    $RemoveForm.before('<div class=\"crearAlertaMensaje\"></div>');
                    $RemoveForm.remove();
                    $RemoveTituloAlerta.remove();
                    jquery('.crearAlertaMensaje').html(data.description);
                    __fnActualizarBarraUsuario.call(self, data);
                    if ($Form.hasClass('isHabDialog')) {
                        /*
                        if (typeof (_gaq) !== 'undefined') {
                            _gaq.push(['_trackEvent', 'Informacion', 'modalficha', 'avisamesibaja']);
                        }
                        */
                        jquery('#idHabDialogAlertaFichaInmueble #wmFooter').html('<a href=\"#\" class=\"boton button-large closeAModalCerrar\">'
                            + self.__alertDTO.Translate.idDialogFooterCerrarAlertaModal + '<\a>');
                    } else {
                        jquery.subscribe(HabEvents.EventsEnum.ClickCrearAlertaDesdeFicha, ['Informacion', 'ficha', 'crearalerta']);
                    }
                }
            }, 'json');
        }
    };

    var __fnActualizarBarraUsuario = function (data) {
        if (data.favoritos !== undefined) {
            jQuery("#idMasMenuFavoritosCount").attr("data-counter", data.favoritos);
        }
    };


    var __fnRegistrarAlertaInmueble = function ($Form) {
        var self = this;
        var $Email, $Error, sError, numForm;
        numForm = '';

        if ($Form.attr('id').indexOf('_')) {
            numForm = '_' + $Form.attr('id').split('_')[1];
        }

        $Email = $Form.find('#id_email_FormAlerta' + numForm);
        $Error = jquery('#idHabDialogAlertaFichaInmueble .error-texto');
        $Form.find('.loadingRegistrarAlerta').removeClass('ocultar').addClass('mostrar');
        sError = '';
        if ($Email.val() === '' || !Functions.ValidateEmail($Email[0])) {
            $Form.find('.loadingRegistrarAlerta').removeClass('mostrar').addClass('ocultar');
            sError = ($Email.val() === '') ? self.__alertDTO.Translate.idErrBadMailEmpty : self.__alertDTO.Translate.idErrBadMail;

            if ($Form.hasClass('isHabDialog')) {
                $Error.removeClass('ocultar').addClass('mostrar').html(sError);
                $Form.find('#id_email_FormAlerta' + numForm).addClass('error');
            } else {
                alert(sError);
            }
            jquery.publish(HabEvents.EventsEnum.ErroresForm, ['form-alerta_ficha_inmueble', 'Email incorrecto o no informado']); 
            return false;
        } else {

            if ($Form.hasClass('isHabDialog')) {
                $Error.removeClass('mostrar').addClass('ocultar').html('');
                $Form.find('#id_email_FormAlerta' + numForm).removeClass('error');
            }

            jquery.post(self.__alertDTO.UrlRegistrarAlertaInmueble, $Form.serialize(), function (data) {

                if (data.status === 0) {
                    var $RemoveForm, $RemoveTituloAlerta;
                    $RemoveTituloAlerta = jquery('.titFormAlerta');
                    $RemoveForm = jquery('.frmRegistrarAlerta.inmueble');
                    $RemoveForm.before('<div class=\"crearAlertaMensaje\"></div>');
                    $RemoveForm.remove();
                    $RemoveTituloAlerta.remove();
                    jquery('.crearAlertaMensaje').html(data.description);
                    __fnActualizarBarraUsuario.call(self, data);
                    if (self.__alertDTO.idUsuario > 0) {
                        //jquery('.botongrisbasico.avisame').tooltip({ disabled: false });
                        jquery('.botongrisbasico.avisame').attr('data-modalType', -1);
                        jquery('.botongrisbasico.avisame').attr('title', self.__alertDTO.Translate.eliminarAlerta);
                        jquery('.botongrisbasico.avisame').attr('class', 'botongrisbasico avisameselect sprite modalAvisame');
                        jquery('.addfav').attr('class', 'favorito sprite removefav');
                        jquery('.removefav').attr('title',self.__alertDTO.Translate.eliminarFavorito);
                    }
                    if ($Form.hasClass('isHabDialog')) {
                        /*
                        if (typeof (_gaq) !== 'undefined') {
                            _gaq.push(['_trackEvent', 'Informacion', 'modalficha', 'avisamesibaja']);
                        }
                        */
                        jquery('#idHabDialogAlertaFichaInmueble #wmFooter').html('<a href=\"#\" class=\"boton button-large closeAModalCerrar\">'
                            + self.__alertDTO.Translate.idDialogFooterCerrarAlertaModal + '<\a>');
                    }  /*else {
                       
                        if (typeof (_gaq) !== 'undefined') {
                            _gaq.push(['_trackEvent', 'Informacion', 'ficha', 'crearalerta']);
                            _gaq.push(['_trackPageview', '/alta_alerta_anuncio']);
                        }
                       
                    } */
                    jquery.publish(HabEvents.EventsEnum.RegistroAlertaCriterioListado);
                }
            }, 'json');
        }
    };

    Alert.prototype = {
        constructor: Alert
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = new Alert(AlertDTO);
    }
    else {
        window.Alert = Alert;
    }
}());